"use client";

import styled from "styled-components";

//Components
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import Image from "../image";

export const DropdownProfile = styled(DropdownMenu)``;

export const ButtonNotfication = styled(DropdownMenuTrigger)`
  position: relative;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--backgroundColorCard);
  color: var(--textLight);
  border: 1px solid var(--textLight);
  border-radius: 0.5rem;
  font-size: 14px;

  &:hover {
    background: rgba(75, 85, 99, 0.1);
  }

  svg {
    width: 18px;
    height: 18px;
    path {
      transition: all 0.3s easy-out;
      fill: var(--colorTitle);
    }
  }
`;

export const ProfileContent = styled(DropdownMenuContent)`
  width: 230px;
  background: var(--backgroundColorCard);
  position: relative;
  z-index: 999;
  padding: 10px;
`;

export const ButtonItemNotfication = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
  cursor: pointer;

  svg {
    margin-top: 2px;
  }
`;

export const Text = styled.span`
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--textColor);
`;
